import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { RoutingModule } from './routing/routing.module'

const routes: Routes = []

@NgModule({
  imports: [RouterModule.forRoot(routes), RoutingModule],
  exports: [RouterModule, RoutingModule],
})
export class AppRoutingModule {}
